import { render, staticRenderFns } from "./BillableRateManagementDetailTabs.vue?vue&type=template&id=966aca3a"
import script from "./BillableRateManagementDetailTabs.vue?vue&type=script&lang=js"
export * from "./BillableRateManagementDetailTabs.vue?vue&type=script&lang=js"
import style0 from "./BillableRateManagementDetailTabs.vue?vue&type=style&index=0&id=966aca3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports